import React from 'react';

import { Box, Card, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const SideMenuCard = ({ children, icon, sxCardBody, title }) => (
    <Card sx={{ mb: '16px !important' }}>
        <Card.Header>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {icon}
                <Typography variant="body2" ml={1} fontWeight="bold">
                    {title}
                </Typography>
            </Box>
        </Card.Header>

        <Card.Body sx={sxCardBody}>{children}</Card.Body>
    </Card>
);

SideMenuCard.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    icon: PropTypes.object,
    sxCardBody: PropTypes.object,
    title: PropTypes.string,
};

export default SideMenuCard;
